/**
 * Shared clipboard utility for copying text across the application.
 * Handles both modern clipboard API and fallback methods for in-app browsers.
 */

/**
 * Copies text to clipboard with fallback for browsers without clipboard API support
 * @param text - The text to copy
 * @returns Promise that resolves when copy is successful
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    // Modern clipboard API - works in most browsers
    await navigator.clipboard.writeText(text)
  } catch {
    // Fallback for browsers without clipboard API (some in-app browsers)
    // Use the deprecated execCommand as a last resort
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.setAttribute('readonly', '')
    textArea.style.position = 'fixed'
    textArea.style.left = '-9999px'
    textArea.style.top = '0'
    textArea.style.opacity = '0'
    textArea.style.fontSize = '16px' // Prevent iOS auto-zoom on focus
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
    } finally {
      document.body.removeChild(textArea)
    }
  }
}
